import { ReactNode, HTMLProps } from 'react'
import cx from 'classnames'

import DropdownStyles from 'common/Dropdown/Dropdown.module.scss'
import { Dropdown, Props as DropdownProps } from 'common/Dropdown/Dropdown'

type Value = string | number

interface Props {
  className?: string
  disabled?: boolean
  dropdownClassName?: string
  dropdownListClassName?: string
  dropdownProps?: Partial<Omit<DropdownProps, 'containerClassName' | 'dropdownClassName' | 'trigger' | 'triggerOn'>>
  inputProps?: HTMLProps<HTMLInputElement>
  name: string
  options: { label: ReactNode; value: Value }[]
  setFieldValue: (name: string, value: Value) => void
  submitFieldValue?: (name: string, value: Value) => void
  value?: Value
}

export const DropdownInput = ({
  className,
  disabled,
  dropdownClassName,
  dropdownListClassName,
  dropdownProps,
  inputProps,
  name,
  options,
  setFieldValue,
  submitFieldValue,
  value,
}: Props) => {
  return (
    <Dropdown
      containerClassName={cx(className)}
      dropdownClassName={cx(DropdownStyles.dropdownContainer, dropdownClassName)}
      trigger={
        <input
          {...inputProps}
          autoComplete="off"
          name={name}
          onChange={({ target: { value } }) => setFieldValue(name, value)}
          value={value}
        />
      }
      triggerOn="click"
      {...dropdownProps}
    >
      <ul className={cx(DropdownStyles.dropdownList, dropdownListClassName)}>
        {options.map((option) => (
          <li key={option.value}>
            <button
              disabled={disabled}
              className={cx({ [DropdownStyles.active]: value === option.value })}
              onClick={() =>
                submitFieldValue ? submitFieldValue(name, option.value) : setFieldValue(name, option.value)
              }
              type="button"
            >
              {option.label}
            </button>
          </li>
        ))}
      </ul>
    </Dropdown>
  )
}
